import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from '~/decorators';
import './ListSwitcher.scss';

export default
@translate('home.table.list-switcher')
class ListSwitcher extends Component {
  static propTypes = {
    active: PropTypes.string.isRequired,
    duelMode: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    colors: PropTypes.shape({
      color: PropTypes.string,
      activeColor: PropTypes.string,
    }),
  };

  render() {
    const {
      t,
      onChange,
      active,
      duelMode,
      colors: { color, activeColor },
    } = this.props;

    return (
      <div className="list-switcher" style={{ color }}>
        <a style={active === 'start-list' ? { color: activeColor } : {}} onClick={() => onChange('start-list')}>
          {t('Start List')}
        </a>

        <a
          style={active !== 'start-list' ? { color: activeColor } : {}}
          onClick={() => onChange(duelMode ? 'duel' : 'leaderboard')}
        >
          {t('Leaderboard')}
        </a>
      </div>
    );
  }
}
